import axiosInstance from '@utils/interceptor'
import { toast } from 'react-toastify'

const PREFERENCE_BASE_URL = '/userPreference/api/v1/preference'

export async function getUserPreference<T>(context: string): Promise<T | null> {
  try {
    const response = await axiosInstance.get<T>(PREFERENCE_BASE_URL, {
      params: { context },
    })
    return response.data ?? null
  } catch (err) {
    // Reads are non-critical: treat a failed load as "no preference saved" so
    // callers fall back to defaults instead of throwing / rejecting.
    console.warn('Failed to load user preference', { context, err })
    toast.warning('Could not load saved preferences. Defaults have been applied.', {
      toastId: 'pref-load-failed',
    })
    return null
  }
}

export async function putUserPreference<T>(context: string, value: T): Promise<void> {
  try {
    await axiosInstance.put(PREFERENCE_BASE_URL, {
      context,
      jsonValue: value,
    })
  } catch (err) {
    // Saves are non-critical: never let a failed save surface as an unhandled
    // rejection. The in-memory value still applies via onCardPrefsChange.
    console.warn('Failed to save user preference', { context, err })
    toast.error('Could not save your preferences. Your latest changes may not be persisted.', {
      toastId: 'pref-save-failed',
    })
  }
}
